import React from 'react';

function StarShopBtn({ handleStarShopOpen }) {
  return (
    <div className="star_bottom">
      <div className="btn_wrap">
        <button
          type="button"
          className="btn btn-blue"
          onClick={handleStarShopOpen}
        >
          스타샵 가기
        </button>
      </div>
      <div className="txt_wrap">
        <p>
          <span className="hide_m">
            AI바로셈 학습을 통해 적립한 내역만 확인할 수 있습니다.{" "}
          </span>
          전체 별 적립내역은 스타샵에서 확인해 주세요.
        </p>
      </div>
    </div>
  );
}

export default StarShopBtn;